var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 375.148 375.148",
    style: {
      enableBackground: "new 0 0 375.148 375.148"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M222.076,218.936h-68.963c-5.771,0-10.449,4.678-10.449,10.449v135.314c0,5.771,4.678,10.449,10.449,10.449h68.963 c5.771,0,10.449-4.678,10.449-10.449V229.385C232.525,223.614,227.847,218.936,222.076,218.936z M211.627,354.25h-48.065V239.834 h48.065V354.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.958,136.911h-69.486c-5.771,0-10.449,4.678-10.449,10.449v217.339c0,5.771,4.678,10.449,10.449,10.449h69.486 c5.771,0,10.449-4.678,10.449-10.449V147.36C369.407,141.59,364.729,136.911,358.958,136.911z M348.509,354.25h-48.588V157.809 h48.588V354.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.717,269.613H16.231c-5.771,0-10.449,4.678-10.449,10.449v84.637c0,5.771,4.678,10.449,10.449,10.449h69.486 c5.771,0,10.449-4.678,10.449-10.449v-84.637C96.166,274.292,91.488,269.613,85.717,269.613z M75.268,354.25H26.68v-63.739 h48.588V354.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.452,10.479c-1.589-2.19-4.089-3.536-6.792-3.657L268.574,0.03c-5.771-0.433-10.8,3.895-11.233,9.665 c-0.433,5.771,3.894,10.8,9.665,11.233l67.297,4.57l-123.721,96.786l-94.563-74.188c-4.038-3.198-9.803-2.976-13.584,0.522 L5.26,141.613c-4.131,3.919-4.363,10.425-0.522,14.629c1.864,2.419,4.786,3.783,7.837,3.657c2.756-0.039,5.385-1.166,7.314-3.135 l90.384-86.727l93.518,73.665c3.817,3.056,9.244,3.056,13.061,0L350.601,39.624l-5.227,64.896 c-0.026,5.674,4.279,10.431,9.927,10.971h0.522c5.386,0.027,9.91-4.045,10.449-9.404l6.792-88.294 C373.447,15.074,372.471,12.34,370.452,10.479z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.25306290.svg";
export { ForwardRef as ReactComponent };